import React from 'react';
import styles from './index.module.scss'
import cupra from '../../../../App/imgs/cupra/cupra-icon.svg';

class Loading extends React.Component {

  render() {
    return (
      <>
        <div style={{ zIndex: '1060', position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, display: 'flex', width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white' }}>
          <div className={styles.lds_circle}><div><img alt='cupra' src={cupra}></img></div></div>
        </div>
      </>
    )
  }
}

export default Loading